import { z } from "zod";

/**
 * Müvekkil portföy sorumluluğu şemaları (CLOS-247 `[135]`).
 *
 * Büro-İÇİ operasyon kaydı: sorumlu kullanıcı, iç öncelik ve takip notu. Sorumluluk
 * ERİŞİM DEĞİLDİR — müvekkil/sözleşme kayıt erişimi, temsil, onay veya imza yetkisi
 * vermez; iç not büro dışına hiçbir görünümde çıkmaz.
 */

export const PORTFOLIO_PRIORITIES = ["low", "normal", "high"] as const;
export type PortfolioPriority = (typeof PORTFOLIO_PRIORITIES)[number];

const oncelikAlani = z.enum(PORTFOLIO_PRIORITIES, "Geçerli bir öncelik seçilmelidir").optional();
const notAlani = z.string().trim().max(2000, "İç not en fazla 2000 karakter olabilir").optional();

export const createPortfolioAssignmentSchema = z.strictObject({
  serviceRelationshipId: z.uuid("Geçerli bir hizmet ilişkisi seçilmelidir"),
  assigneeUserId: z.uuid("Geçerli bir kullanıcı seçilmelidir"),
  priority: oncelikAlani,
  internalNote: notAlani,
});
export type CreatePortfolioAssignmentInput = z.infer<typeof createPortfolioAssignmentSchema>;

/** Sorumlu değişikliği — eski atama kapanır, yeni satır açılır (sessiz üzerine yazma yok). */
export const reassignPortfolioAssignmentSchema = z.strictObject({
  assigneeUserId: z.uuid("Geçerli bir kullanıcı seçilmelidir"),
  priority: oncelikAlani,
  internalNote: notAlani,
});
export type ReassignPortfolioAssignmentInput = z.infer<typeof reassignPortfolioAssignmentSchema>;

export type PortfolioAssignmentStatus = "active" | "closed";
export type PortfolioClosedReason =
  "reassigned" | "manual" | "relationship_suspended" | "relationship_ended";

export type ClientPortfolioAssignmentView = {
  id: string;
  clientId: string;
  serviceRelationshipId: string;
  assigneeUserId: string;
  assigneeName: string;
  priority: PortfolioPriority;
  internalNote: string | null;
  status: PortfolioAssignmentStatus;
  closedReason: PortfolioClosedReason | null;
  closedAt: string | null;
  createdByName: string;
  createdAt: string;
};

/** Ekranda görünen adlar — metin şemanın yanında (bkz. temsil daveti şemaları). */
export const PORTFOLIO_PRIORITY_NAMES: Record<PortfolioPriority, string> = {
  low: "Düşük öncelik",
  normal: "Normal öncelik",
  high: "Yüksek öncelik",
};

export const PORTFOLIO_ASSIGNMENT_STATUS_NAMES: Record<PortfolioAssignmentStatus, string> = {
  active: "Aktif sorumluluk",
  closed: "Kapandı",
};

/**
 * Kapanış gerekçesi: sorumluluğun neden bittiği. "reassigned" ile "manual" ayrımı önemli —
 * biri devirdir, diğeri boşluktur; ikisi tek kelimeye indirilirse portföyde kimsenin
 * bakmadığı müvekkil görünmez olur.
 */
export const PORTFOLIO_CLOSED_REASON_NAMES: Record<PortfolioClosedReason, string> = {
  reassigned: "Sorumlu değişti",
  manual: "Elle kapatıldı",
  relationship_suspended: "Hizmet ilişkisi askıya alındı",
  relationship_ended: "Hizmet ilişkisi sona erdi",
};
